import classNames from 'classnames';
import castArray from 'lodash/castArray';

import style from './TaskFieldView.module.scss';
import '@components/mixins/commonStyles.scss';

import { Optional } from 'chaika-frontend-types/frontend-cms';

import { isDefined } from '@utils/isDefined';

export interface TaskFieldViewProps {
    highlight?: boolean;
    heading?: string;
    dataTest?: string | Optional<string>[];
    label?: string | Optional<string>[];
    hint?: string | Optional<string>[];
    value?: string | Optional<string>[];
    rowDirection?: boolean;
    onClick?(): void;
}

interface Props {
    label?: string;
    hint?: string;
    value?: string;
    dataTest?: string;
    rowDirection?: boolean;
    onClick?(): void;
}

export function TaskFieldView({
    highlight,
    label,
    heading,
    hint,
    value,
    dataTest,
    rowDirection,
    onClick,
}: TaskFieldViewProps): React.ReactElement<any> | null {
    const labels = castArray(label);
    const hints = castArray(hint);
    const values = castArray(value);
    const dataTests = castArray(dataTest);

    const hasValues = values.some(isDefined);

    const headingView = isDefined(heading) ? (
        <div className={classNames(['font_h3', style.heading])}>{heading}</div>
    ) : null;

    return hasValues ? (
        <div className={classNames([style.view, highlight && style.highlight])}>
            {headingView}
            <div className={style.fields}>
                {values.map((_, index) =>
                    TaskField({
                        rowDirection,
                        label: labels[index],
                        hint: hints[index],
                        value: values[index],
                        dataTest: dataTests[index],
                        onClick,
                    }),
                )}
            </div>
        </div>
    ) : null;
}

function TaskField({ label, value, dataTest, rowDirection, hint, onClick }: Props): React.ReactElement<any> | null {
    const labelView = isDefined(label) ? <div className={classNames(['font_label', style.hint])}>{label}</div> : null;

    const hintView = isDefined(hint) ? <div className={style.hint}>{hint}</div> : null;

    return isDefined(value) ? (
        <div
            className={classNames([style.field, rowDirection && style.rowDirection])}
            key={value}
            data-test={dataTest}
            data-testid={dataTest}
        >
            {labelView}
            <div
                className={classNames([style.value, isDefined(onClick) && style.link])}
                onClick={onClick}
            >
                {value}
                {hintView}
            </div>
        </div>
    ) : null;
}
